const i18n = {
  'Member authentication error: "INVALID-LOGIN-PASSWORD"': 'Неправильный логин или пароль',
  'Member authentication error: "INACTIVE-MEMBER"': 'Пользователь не активен',
  'This member does not exist in panel.': 'Пользователь с таким email не зарегистрирован',
  'This email does not exist in database.': 'Пользователь с таким email не найден',
  'This value should not be blank.': 'Поле не может быть пустым',
  'Member already exist in panel': 'Такой пользователь уже зарегистрирован',
  'This value is not a valid email address.': 'Некорректный email',
  'This value is too short. It should have 1 character or more.':
    'Значение слишком короткое. Должен быть один или более символов.',
  'Multiple members found by unique data-points': 'Такой email уже зарегистрирован',
  'Incorrect session key': 'Неверный код подтверждения',
  'Session key expired': 'Срок действия кода истек. Запросите новый код, чтобы продолжить регистрацию',
  'Number of attempts exceeded': 'Превышен лимит запросов. Запросите новый код, чтобы продолжить регистрацию',

  'Rate limit exceeded': 'Превышен лимит запросов. Попробуйте снова через час',

  'The manager sender is not filled in this panel.':
    'Отправка обращения сейчас недоступна. Попробуйте позже или напишите в поддержку',

  'Password must be a string of 8 or more characters':
    'Пароль должен содержать не менее 8 символов',
  'Password may contain only Latin letters, digits and special characters':
    'Пароль может содержать только латинские буквы, цифры и специальные символы',
  'Password must contain at least one Latin letter and at least one digit':
    'Пароль должен содержать хотя бы одну латинскую букву и хотя бы одну цифру',

  'global_error.multipleMembers': 'Пользователь с таким email уже существует',
  'global_error.unknown_error': 'Что-то пошло не так. Попробуйте позже',
};

export default i18n;
